export default "__VITE_ASSET__CgGjcueC__"